module.exports = __webpack_public_path__ + "img/parrot.be5030ca.webp";